import type { ExteriorMaterialOverride } from "building-types/materials/materialTypes";
import type { PolyLine3 } from "geom/polyLine3";

export interface PorchHeaderKeyMeasures {
  rail: PolyLine3;
  width: number;
  depth: number;
}

export interface PorchKeyMeasures {
  columnHeight: number;
  columnCount: number;
  name: string;
  headers: PorchHeaderKeyMeasures[];
}

export enum PorchKeyMeasuresGeometryType {
  NONE = "NONE",
  COLUMN = "COLUMN",
  COLUMN_STRUCTURE = "COLUMN_STRUCTURE",
  HEADER = "HEADER",
  HEADER_TRIM = "HEADER_TRIM",
}
export interface ExteriorMaterialOverrideWithKeyMeasures extends ExteriorMaterialOverride {
  readonly porchKeyMeasuresGeometryType: PorchKeyMeasuresGeometryType;
  /** Porch-local index shared by a column's structural extrusion and all of its casing pieces. */
  readonly columnIndex?: number;
}
